<template>
  <config-base ref="baseRef" :on="$listeners">
    <template #config>
      <capacity-config-list :config-plan-type="planType" :config-capacity-key="capacityKey" :capacity-unit-i18n-key="capacityUnitI18nKey"></capacity-config-list>
    </template>
  </config-base>
</template>

<script>
import {get, map} from "lodash";
import {mapGetters} from "vuex";
import planCommon from '@/plans/LARGE_MEETING/mixin';
import {getPlanTotalLicense} from "@/common/service/validate";
import {getNeedFilterCapacityList} from '@/common/product';
import {computedLargeMeetingPlans} from "@/common/service/computers/plans/large-meeting";
import plansMixin from "@/plans/mx/plan";
import ConfigList from "@/components/capacity/config-list.vue";
import ConfigBase from "@/plans/LARGE_MEETING/config/base.vue";

const CapacityConfigList = {
  name: 'CapacityConfigList',
  extends: ConfigList,
  mixins: [planCommon],
  computed: {
    ...mapGetters(['getCurrentMeetingPlans', 'getCurrentBasePlanInfo', 'boughtPlans', 'hasBoughtDependPlan']),
    boughtCurrentPlans() {
      return computedLargeMeetingPlans(this.boughtPlans)
    },
    planList() {
      return this.planMapFlat.filter((p) => {
        const isCurrentPlanType = p.type === this.planType;
        const isSupportCapacity = this.supportCapacity.includes(p[this.capacityKey]);
        const isBoughtCapacity = map(this.boughtCurrentPlans, this.capacityKey).includes(p[this.capacityKey]);
        const needFilterCapacity = getNeedFilterCapacityList(this.getCurrentBasePlanInfo?.plans).includes(p[this.capacityKey])
        return isCurrentPlanType && isSupportCapacity && !needFilterCapacity && !isBoughtCapacity;
      });
    },
    mx_licenseTips() {
      return this.totalLimitDesc;
    },
    currentBasePlans() {
      return this.getCurrentMeetingPlans.length ? this.getCurrentMeetingPlans : this.getCurrentBasePlanInfo?.plans;
    },
    editTotalLimitDesc() {
      const basePlanNameKey = get(this.currentBasePlans, [0, 'parentPlanNameKey']) || get(this.currentBasePlans, [0, 'planNameKey']) || get(this.currentBasePlans, [0, 'typeNameKey'])
      return this.$t(
        this.hasBoughtDependPlan ?
        'billing.addon_license_limit_tips' :
        'billing.addon_license_limit_tips_without_contact',
        [this.title, this.$t(basePlanNameKey)])
    },
    addAnotherCapacityCta() {
      return this.$t('billing.addAnother.large');
    }
  },
  methods: {
    handleLicenseChange(license, capacity) {
      const condition = license >= this.mx_getMaxHosts() && this.mx_getMaxHosts() !== 999;
      this.$set(this.mx_license_capacityAlertMap, capacity, condition ? this.editTotalLimitDesc : "");
    },
    mx_getMaxHosts() {
      return getPlanTotalLicense(this.currentBasePlans || []) || 999;
    },
    mx_getDeleteVisible(capacity){
      return !(
        this.selectedPlanList?.length === 1
        && capacity === this.selectedPlanList?.[0].capacity)
    },
  }
}
export default {
  mixins: [plansMixin, planCommon],
  components: { ConfigBase, CapacityConfigList }
};
</script>

<style lang="scss">
</style>
